module.exports = __webpack_public_path__ + "static/media/book-search-delete.afba9a23.svg";